// The same pricing the square-payments edge function charges.
import { cardSurchargeCents } from "../../../supabase/functions/_shared/square-order-body.ts";

interface PaymentMethodTotalProps {
  method: "square" | "etransfer";
  /** The amount the customer picked, else the quote total, or the balance once something has been paid. */
  amount: number;
  isBalance: boolean;
  /** The customer picked the deposit over paying in full (#1163). */
  isDeposit?: boolean;
  /** From get_public_quote; 0 when the card fee is off. */
  surchargePercent: number;
}

/**
 * What the customer pays with the payment method they've picked (#982). Card
 * payments carry the processing fee; e-transfer shows the plain amount. When
 * the customer picks deposit or full (#983), `amount` is that pick, so the box
 * shows what the next click charges (#1163). With no choice shown it is the
 * total, while the next click charges a deposit, so the note gives the fee as
 * a percentage, not dollars.
 */
export function PaymentMethodTotal({ method, amount, isBalance, isDeposit, surchargePercent }: PaymentMethodTotalProps) {
  const fee = method === "square" ? cardSurchargeCents(Math.round(amount * 100), surchargePercent) / 100 : 0;
  const label = `${isBalance ? "Balance" : isDeposit ? "Due now" : "Total"} by ${method === "square" ? "credit card" : "e-transfer"}`;
  return (
    <div className="rounded-lg bg-muted/40 px-4 py-3 text-sm space-y-1" aria-live="polite">
      <div className="flex justify-between font-semibold">
        <span>{label}</span>
        <span>${(amount + fee).toFixed(2)}</span>
      </div>
      {fee > 0 && (
        <p className="text-xs text-muted-foreground">
          Includes a {surchargePercent}% card processing fee, added to each card payment. E-transfer has no fee.
        </p>
      )}
    </div>
  );
}
